var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeadlinesMergeFeedbackKo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 161",
    style: {
      enableBackground: "new 0 0 160 161"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#9FC3CD;fill-opacity:0.4;}\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{mask:url(#mask-2_1_);}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#B28B67;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#2F3676;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#E4E4E4;}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#997659;}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#5C63AB;}\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:#191847;}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:#E87613;}\n\t.st11{fill-rule:evenodd;clip-rule:evenodd;fill:#F2F2F2;}\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:#FF9B21;}\n\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill-opacity:0.1;}\n\t.st14{fill:#D82829;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(-47.000000, -6.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Mask-Copy",
    className: "st0",
    cx: 127,
    cy: 86.5,
    rx: 79,
    ry: 79.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Human"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 57.8,
    y: 25.5,
    width: 95.3,
    height: 184.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 57.8,
    y: 25.5,
    width: 95.3,
    height: 184.4,
    id: "mask-2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1_1_",
    className: "st2",
    d: "M113.1,0l0,8.6c4.1-0.6,8.3-1,12.5-1C169.5,7.6,205,43,205,86.7s-35.5,79.1-79.4,79.1 s-79.4-35.4-79.4-79.1c0-20.7,8-39.6,21-53.7L0,33.1V0H113.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1_",
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.257344, 11.926704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bottom_x2F_Standing_x2F_Shorts",
    transform: "translate(0.575990, 103.287908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Leg",
    className: "st4",
    d: "M46.3,0c0.7,9.8,46.9,38.5,47.1,39.3c0.1,0.4-4.7,11.7-14.4,34l4,1.6 c14.9-23.6,21.9-36.7,21.2-39.2c-1.1-3.6-13-15.4-35.8-35.5L46.3,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pant",
    className: "st5",
    d: "M80.2,68.2l6.6,2.4c13.9-15.6,19.3-28.5,18.3-35.1C104.5,31.1,92.6,19.3,69.4,0L45.9,0 C46.7,22.6,89.5,39.4,90,40.3S85,50.7,80.2,68.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(76.641590, 66.315924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-Show",
    transform: "translate(12.119043, 7.928775) rotate(20.000000) translate(-12.119043, -7.928775) "
  }, /*#__PURE__*/React.createElement("path", {
    id: "shoe",
    className: "st6",
    d: "M0.6,11.4c-0.1,0.5-0.2,1-0.2,1.3c0,0.7,0.1,1.8,0.4,3.1c0.8,0,8.3,0,22.4,0 c0.6-1.9,0.2-3-1-3.1c-1.3-0.2-2.3-0.3-3.1-0.4L9.2,7.9C8.7,7.7,8.1,8,7.9,8.5c0,0,0,0,0,0l-0.4,1l0,0 c-1.2,0.5-2.1,0.8-2.8,0.8c-0.4,0-0.8-0.1-1.4-0.3l0,0c-1-0.4-2.2,0.2-2.5,1.2C0.6,11.3,0.6,11.4,0.6,11.4z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Leg_1_",
    className: "st7",
    points: "51.7,0 31.1,49.2 10.9,90.9 15.7,90.9 67.8,0  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Left-Shot",
    transform: "translate(9.536296, 78.891309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shoe_1_",
    className: "st6",
    d: "M0.6,11.4c-0.1,0.5-0.2,1-0.2,1.3c0,0.7,0.1,1.8,0.4,3.1c0.8,0,8.3,0,22.4,0 c0.6-1.9,0.2-3-1-3.1c-1.3-0.2-2.3-0.3-3.1-0.4L9.2,7.9C8.7,7.7,8.1,8,7.9,8.5c0,0,0,0,0,0l-0.4,1l0,0 c-1.2,0.5-2.1,0.8-2.8,0.8c-0.4,0-0.8-0.1-1.4-0.3l0,0c-1-0.4-2.2,0.2-2.5,1.2C0.6,11.3,0.6,11.4,0.6,11.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pant_1_",
    className: "st8",
    d: "M12.7,82.2l10.6,2c8.2-12,42.5-61.3,46.2-84.2H46C33.4,16.6,20.5,70,12.7,82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head_x2F_Front_x2F_Curly",
    transform: "translate(30.187101, 1.717131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(28.036765, 16.041711)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M19.8,4.7c3,5.6,2.7,19.8-1.2,20.8c-1.6,0.4-4.9-0.6-8.2-2.6l2.1,14.9H0l4.3-19.9 c-2.4-2.8-4-6.2-3.7-10.1C1.3-3.3,16.8-0.9,19.8,4.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hair",
    className: "st9",
    d: "M49,23.3c-0.1-0.7-0.4-1.5-0.7-2.2c-0.3-0.9-0.8-1.7-1.3-2.4c-1-1.4-2.2-2.7-3.5-3.7 c-2.4-1.9-5.4-3.1-8.4-2.7c-1.5,0.2-3,0.8-4.2,1.7c-1.1,0.9-2.2,2.1-3.7,2.2c-1.6,0.1-3-1.3-4.3-2.2c-1.4-1-3-1.7-4.6-1.9 c-2.8-0.5-5.4,0.5-7.4,2.8c-2.1,2.4-3.5,6-2.2,9.2c0.3,0.6,0.6,1.1,1,1.5c0.4,0.4,1.1,0.8,1.2,1.4c0.2,0.7-0.4,1.5-0.6,2.1 c-0.3,0.8-0.6,1.7-0.5,2.6c0.1,1.5,1.1,2.9,2.1,3.9c1,1,2.3,1.6,3.6,1.9c0.9,0.2,1.8,0.3,2.7,0.2c0.5,0,0.9-0.2,1.3-0.3 c0.4-0.1,0.7,0,1,0.2c1.7,1.1,3.5,1.5,5.4,1.3c1.6-0.1,3.5-0.5,4.9-1.6c1.5-1.2,1.5-3,1.1-4.8c0.4,0.2,1.4,0.3,0.8-0.4 c-0.2-0.3-0.7-0.4-1-0.6c-0.4-0.2-0.7-0.5-1-0.8c-1.1-1.3,0-3.9,1.4-4.4c2.1-0.6,2.6,2.3,4.1,3.1c0.9,0.4,1.8-0.2,2.4-0.8 c0.9-0.8,1.5-1.9,2-3c0.4-0.9,0.8-1.9,1.2-2.8c0.2-0.4,0.9-1.6,0.5-2.1c1.5-0.3,3.2,0.3,4.5,1.2c0.5,0.3,1,0.7,1.2,1.3 c0.1,0.1,0.2,0.5,0.4,0.5C49.2,23.8,49,23.5,49,23.3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Body_x2F_Hoodie",
    transform: "translate(64.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    className: "st4",
    d: "M17.3,47.4l10.6,0C21.3,68.5,17.8,79.7,17.3,81c-1.2,2.9,1.3,7.3,2.4,9.7c-1.5,0.7-2.3-0.1-3.1-1 l-0.2-0.2c-0.9-1-1.9-2-4.1-1c-4,1.8-7,5.2-11.6,2.4c-0.6-0.3-1.2-1.7,0.3-2.7c1.1-0.7,2.3-1.6,3.5-2.6L5,85.2 c2.7-2.2,5.3-4.5,5.8-5.5c0.5-1,1.3-4.2,2.4-9.6l0.1-0.7C14.3,64.1,15.7,56.8,17.3,47.4L17.3,47.4z M79.2,47l16.1,11.9 c4.4,1.2,8,2.7,11,4.4c0.7,0.6,1.5,1.9-1.3,1.7c-2.9-0.2-5.9-0.3-6.3,0.7c-0.4,1,1.3,2.2,0.5,3.5c-0.5,0.9-3.1-1.3-7.6-6.6 l-16-6.6L79.2,47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Coat-Back",
    className: "st10",
    d: "M46.9,2.7L51.3,2C67.6,16,74.2,43.1,94.2,57.4l-4.8,6C54.8,59.1,46.2,26.1,46.9,2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shirt",
    className: "st11",
    d: "M28,58c17.5,0,30.4,0,38.6,0c1.8,0,1.4-2.6,1.2-3.9c-2.9-15-14.4-31.1-14.4-52.4L42.2,0 C33,14.9,29.8,33.3,28,58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Coat-Front",
    className: "st12",
    d: "M41.1,0L41.1,0l4.5,0.3C55.5,34,58.3,56.5,54,68l-0.1,0.3l-30.4,0 c-1.8,4.2-3.5,7.8-5.2,10.6l0,0h-8.3C9.1,46.3,19.4,19.9,41.1,0l-0.4,0.4L40.9,0H41.1L41.1,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shade",
    className: "st13",
    d: "M35,69l-11,0c2-5.1,4.2-11.1,6.5-18C31.4,59.3,32.9,65.3,35,69z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(155.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    className: "st2",
    cx: 24,
    cy: 24,
    rx: 19.1,
    ry: 23
  }), /*#__PURE__*/React.createElement("path", {
    id: "t",
    className: "st14",
    d: "M27,47.2c12.8,0,23.2-10.4,23.2-23.2S39.8,0.8,27,0.8S3.7,11.2,3.7,24S14.2,47.2,27,47.2z  M33.1,35.4L27,29.3l-6.1,6.1c-0.4,0.4-1.2,0.4-1.6,0l-3.7-3.7c-0.4-0.4-0.4-1.2,0-1.6l6.1-6.1l-6.1-6.1c-0.4-0.4-0.4-1.2,0-1.6 l3.7-3.7c0.4-0.4,1.2-0.4,1.6,0l6.1,6.2l6.1-6.1c0.4-0.4,1.2-0.4,1.6,0l3.7,3.7c0.4,0.4,0.4,1.2,0,1.6L32.2,24l6.1,6.1 c0.4,0.4,0.4,1.2,0,1.6l-3.7,3.7C34.2,35.8,33.5,35.8,33.1,35.4z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeadlinesMergeFeedbackKo);
export default __webpack_public_path__ + "static/media/deadlines-merge-feedback-ko.efde4752af0a5d727918f2b0c364bb78.svg";
export { ForwardRef as ReactComponent };